import { useState } from 'react';
import { Link } from 'react-router-dom';
import { hotArticles } from '@/mocks/home';

export default function FeaturedGossip() {
  const featured = hotArticles.slice(0, 3);
  const [hoveredId, setHoveredId] = useState<string | null>(null);

  return (
    <section className="bg-background-100 py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Header */}
        <div className="text-center mb-10">
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-900">
            热门大瓜精选 🔥
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-xl mx-auto">
            全网最火爆的吃瓜事件，实时热度排行，不错过任何一个精彩大瓜
          </p>
        </div>

        {/* Featured Cards - 3 column with hover expansion */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {featured.map((article, idx) => {
            const isHovered = hoveredId === article.id;
            const isOthersHovered = hoveredId && hoveredId !== article.id;

            return (
              <Link
                key={article.id}
                to={`/article/${article.id}`}
                className={`relative rounded-2xl overflow-hidden cursor-pointer transition-all duration-500 ease-out ${
                  isHovered
                    ? 'md:col-span-2'
                    : isOthersHovered
                      ? 'md:col-span-1'
                      : idx === 0
                        ? 'md:col-span-2'
                        : 'md:col-span-1'
                }`}
                style={{ height: '420px' }}
                onMouseEnter={() => setHoveredId(article.id)}
                onMouseLeave={() => setHoveredId(null)}
              >
                {/* Background Image */}
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />

                {/* Gradient Overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-black/10"></div>

                {/* Content */}
                <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                  <div className="flex items-center gap-2 mb-3">
                    <span className="px-3 py-1 rounded-full bg-accent-500/90 text-foreground-950 text-xs font-bold whitespace-nowrap">
                      {article.category}
                    </span>
                    {article.isNew && (
                      <span className="px-2.5 py-1 rounded-full bg-primary-500/90 text-background-50 text-xs font-bold whitespace-nowrap">
                        NEW
                      </span>
                    )}
                  </div>
                  <h3 className="text-lg md:text-xl font-heading font-bold text-background-50 leading-snug">
                    {article.title}
                  </h3>
                  {(isHovered || (idx === 0 && !hoveredId)) && (
                    <p className="mt-2 text-sm text-background-50/70 leading-relaxed line-clamp-2">
                      {article.summary}
                    </p>
                  )}
                  <div className="mt-3 flex items-center gap-4 text-xs text-background-50/60">
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line w-3.5 h-3.5 flex items-center justify-center"></i>
                      {article.views >= 10000
                        ? `${(article.views / 10000).toFixed(1)}万`
                        : article.views}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-message-2-line w-3.5 h-3.5 flex items-center justify-center"></i>
                      {article.comments}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-time-line w-3.5 h-3.5 flex items-center justify-center"></i>
                      {new Date(article.publishedAt).toLocaleDateString('zh-CN', {
                        month: 'short',
                        day: 'numeric',
                      })}
                    </span>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}